import useAxiosFetchApi from '../../hooks/useFetch';
import { useAuth } from '../../hooks/appHooks';
import React, { useState, useMemo } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import EditModal from '../modals/EditModal';
import ConfirmationModal from '../modals/ConfirmationModal';
import AddOrEditAdvertisement from '../admin/AddOrEditAdvertisement';
import useAxiosPrivate from '../../apis/useAxiosPrivate';
import { baseURL, imgURL } from '../../apis/axios';
import InformationModal from '../modals/InformationModal';
import { groupBy } from 'lodash';
import AvailableBanners from '../../utils/AvailableBanners';
import AdvertisementTable from './AdvertisementTable';
import AppLoading from '../../utils/AppLoading';
import { Add } from 'iconsax-reactjs';

const ADVERTISEMENT_LIST_URL = "/advertisements";
const TOGGLE_PUBLISH_URL = "/advertisements/toggle/showing"
const ADVERTISEMENT_DELETE_URL = "/advertisements/delete"

const AdvertisementsList = () => {

    const { auth } = useAuth()
    const { t, i18n } = useTranslation();
    const tAdvertisementInfo = t("advertisementFormIfno")
    const axiosPrivate = useAxiosPrivate()
    const [editModal, setShowEditModal] = useState({ advertisement: null, status: false });
    const [deleteModal, setShowDeleteModal] = useState({ advertisementId: null, status: false });
    const [imagesModal, setShowImagesModal] = useState({ advertisement: null, status: false });
    const [isLoading, setLoading] = useState(false);
    const sessionToken = auth.token;
    const [state, _, setChangeData] = useAxiosFetchApi(ADVERTISEMENT_LIST_URL, {}, sessionToken);
    const advertisementList = state?.data?.data?.list;
    const availableBanners = state?.data?.data?.availableBanners;

    const groupedAdvertisements = useMemo(() => {
        if (!state?.data?.data?.list) return {};
        const sorted = [...state?.data?.data?.list].sort((a, b) => a.priority - b.priority);
        return groupBy(sorted, 'priority');
    }, [state?.data?.data?.list]);

    console.log('state: ', state);


    async function toggleAdvertisementShowing(advertisementId) {
        try {
            setLoading(true)
            const params = `/${advertisementId}`;
            const statusChangedResponse = await axiosPrivate.get(TOGGLE_PUBLISH_URL + params,
                { headers: { 'Accept-Language': i18n.language, 'Content-Type': 'application/json' } }
            );

            setLoading(false)
            const otherAdvertisements = advertisementList.filter(ads => ads.advertisementId !== advertisementId);
            const selectedAdvertisement = advertisementList.filter(ads => ads.advertisementId === advertisementId);
            setChangeData({
                availableBanners: availableBanners,
                message: statusChangedResponse?.data?.message, list: [...otherAdvertisements, {
                    ...selectedAdvertisement[0],
                    isShown: statusChangedResponse?.data.isPublished
                }]
            })

            toast.success(statusChangedResponse?.data.message);
        } catch (error) {
            setLoading(false)
            toast.error(error.response?.data.message);
        }
    }

    const handleOnAdvertisementDelete = async (advertisementId) => {
        try {
            setLoading(true)
            const advertisementDeletedResponse = await axiosPrivate.delete(ADVERTISEMENT_DELETE_URL + `/${advertisementId}`,
                { headers: { 'Accept-Language': i18n.language, 'Content-Type': 'application/json' } }
            );
            setLoading(false)
            const updatedAdvertisements = advertisementList.filter(ads => ads.advertisementId !== advertisementId);
            setChangeData({
                availableBanners,
                list: updatedAdvertisements
            });
            toast.success(advertisementDeletedResponse?.data.message);
        } catch (error) {
            setLoading(false)
            toast.error(error.response?.data.message);
        }
    }

    function onSetChangedData(advertisements) {
        // const otherAdvertisements = advertisementList.filter(ads => ads.advertisementId !== advertisement.advertisementId);
        // const oldAdvertisement = advertisementList.find(ads => ads.advertisementId === advertisement.advertisementId);

        // const updatedAvailableBanners = {
        //     ...availableBanners,
        //     [oldAdvertisement.vendor?.vendorType || "EXTERNAL_ADS"]
        //     : availableBanners[oldAdvertisement.vendor?.vendorType || "EXTERNAL_ADS"]
        //         .replace(oldAdvertisement.priority.toString(), advertisement.priority.toString())
        // };
        setChangeData({
            availableBanners,
            list: (() => {
                const exists = advertisementList.some(ad => ad.advertisementId === advertisements.advertisementId);
                if (exists) {
                    // Replace the old object with the new one
                    return advertisementList.map(ad =>
                        ad.advertisementId === advertisements.advertisementId ? advertisements : ad
                    );
                } else {
                    // Append the new object
                    return [advertisements, ...advertisementList];
                }
            })()
        });
        // advertisements: [...otherAdvertisements, advertisement],
    }

    return (
        <>
            {!editModal && <ToastContainer />}
            <div className='flex flex-col w-full text-black'>
                <div className="flex justify-between mb-10">
                    <h2>{tAdvertisementInfo["advertisements"]}</h2>
                    <button className="flex items-center bg-secondary-color text-white text-sm"
                        onClick={() => setShowEditModal({ advertisement: null, status: true })}
                    >
                        <Add className='text-white' />
                        {" "}
                        {tAdvertisementInfo["addAdvertisementTitle"]}</button>
                </div>

                {state.isLoading && <div>
                    <AppLoading /></div>}
                {!state?.data?.data?.list && <div>
                    <p className='p-10'>{state.data?.data?.message ?? state.error?.message}</p></div>}
                {state?.data?.data?.availableBanners && <AvailableBanners availableBanners={availableBanners} />}
                {state?.data?.data?.list && <AdvertisementTable
                    groupedAdvertisements={groupedAdvertisements}
                    isLoading={isLoading}
                    toggleAdvertisementShowing={toggleAdvertisementShowing}
                    setShowEditModal={setShowEditModal}
                    setShowDeleteModal={setShowDeleteModal}
                    setShowImagesModal={setShowImagesModal}
                />}
            </div>
            <EditModal showModal={editModal.status} setShowModal={setShowEditModal} target="Advertisement">
                <AddOrEditAdvertisement key={editModal.advertisement?.advertisementId}
                    isEdit={editModal.advertisement != null}
                    onEdit={onSetChangedData}
                    currentAdvertisement={editModal.advertisement}
                    setShowEditModal={setShowEditModal} />

            </EditModal>
            <ConfirmationModal
                title={"Confirm advertisement Delete"}
                btnColor={"bg-danger"}
                message={"Are you sure for deleting this advertisement?"}
                onAction={() => { handleOnAdvertisementDelete(deleteModal.advertisementId); setShowDeleteModal({ ...deleteModal, status: false }) }}
                showModal={deleteModal.status}
                setShowModal={setShowDeleteModal} />
            <InformationModal
                title={"Advertisement Image"}
                btnColor={"bg-info"}
                showModal={imagesModal.status}
                setShowModal={setShowImagesModal}>
                <div className='flex justify-between'>
                    <img className='md:w-full h-72 rounded-xl' src={`${imgURL}/${imagesModal.advertisement?.adsImage1}`} alt="ads1" />
                    {/* <img className='md:w-1/4 h-72 rounded-xl' src={`${baseURL}/files/get/file/${imagesModal.advertisement?.adsImage2}`} alt="ads2" />
                <img className='md:w-1/4 h-72 rounded-xl' src={`${baseURL}/files/get/file/${imagesModal.advertisement?.adsImage3}`} alt="ads3" /> */}
                </div>
            </InformationModal>
        </>
    )
}

export default AdvertisementsList